import { Component, OnInit, Input } from '@angular/core';
import { GlobalService } from '../../Services/global.service';
import { MessageService } from 'primeng/api';

import * as L from 'leaflet';
import { ActivatedRoute, Router, NavigationStart, Event, RouterEvent } from '@angular/router';


@Component({
  selector: 'app-tracking',
  // standalone: true,
  // imports: [],
  templateUrl: './tracking.component.html',
  styleUrl: './tracking.component.scss'
})
export class TrackingComponent implements OnInit {
  map: any = '';
  @Input() orderTrack: any

  constructor(public global: GlobalService) {

  }

  order_status: any = []
  driver_recipient_detail: any
  is_task: any = {}
  is_sailer_information: boolean = false
  
  ngOnInit(): void {
    console.log('in tracking component ^^^^^^^^^^')
    // this.initMap();                                                   
    // if (this.orderTrack.task.taskType == 1) { // PICKUP OR DROP

    //   if (this.orderTrack.task.isPickupOrDrop == 0) { // both
    //     this.is_sailer_information = true
    //     this.is_task.recipientName = this.orderTrack.task.dropoffRecipientName ? this.orderTrack.task.dropoffRecipientName : '---'
    //     this.is_task.recipientNumber = this.orderTrack.task.dropoffRecipientPhone ? '+' + this.orderTrack.task.dropoffRecipientPhone : '---'
    //     this.is_task.dropoffAddress = this.orderTrack.task.dropoffAddress ? this.orderTrack.task.dropoffAddress : '---'

    //     this.is_task.sailerName = this.orderTrack.task.pickupRecipientName ? this.orderTrack.task.pickupRecipientName : '---'
    //     this.is_task.sailerNumber = this.orderTrack.task.pickupRecipientPhone ? '+' + this.orderTrack.task.pickupRecipientPhone : '---'

    //   } else if (this.orderTrack.task.isPickupOrDrop == 1) { //pickup
    //     this.is_task.recipientName = this.orderTrack.task.pickupRecipientName ? this.orderTrack.task.pickupRecipientName : '---'
    //     this.is_task.recipientNumber = this.orderTrack.task.pickupRecipientPhone ? '+' + this.orderTrack.task.pickupRecipientPhone : '---'
    //     this.is_task.dropoffAddress = this.orderTrack.task.pickupAddress ? this.orderTrack.task.pickupAddress : '---'

    //   } else if (this.orderTrack.task.isPickupOrDrop == 2) { // drop
    //     this.is_task.recipientName = this.orderTrack.task.dropoffRecipientName ? this.orderTrack.task.dropoffRecipientName : '---'
    //     this.is_task.recipientNumber = this.orderTrack.task.dropoffRecipientPhone ? '+' + this.orderTrack.task.dropoffRecipientPhone : '---'
    //     this.is_task.dropoffAddress = this.orderTrack.task.dropoffAddress ? this.orderTrack.task.dropoffAddress : '---'

    //   }

    // } else if (this.orderTrack.task.taskType == 2) { // appointment
    //   this.is_task.recipientName = this.orderTrack.task.dropoffRecipientName ? this.orderTrack.task.dropoffRecipientName : '---',
    //     this.is_task.recipientNumber = this.orderTrack.task.dropoffRecipientPhone ? '+' + this.orderTrack.task.pickupRecipientPhone : '---',
    //     this.is_task.dropoffAddress = this.orderTrack.task.dropoffAddress ? this.orderTrack.task.dropoffAddress : '---'


    // } else if (this.orderTrack.task.taskType == 3) { //field_workforce
    //   this.is_task.recipientName = this.orderTrack.task.dropoffRecipientName ? this.orderTrack.task.dropoffRecipientName : '---',
    //     this.is_task.recipientNumber = this.orderTrack.task.dropoffRecipientPhone ? '+' + this.orderTrack.task.dropoffRecipientPhone : '---',
    //     this.is_task.dropoffAddress = this.orderTrack.task.dropoffAddress ? this.orderTrack.task.dropoffAddress : '---'
    // }
  }

   initMap(): void {
    // Initialize the map
    this.map = L.map('map').setView([22.29161, 70.79322], 13); // Set default coordinates and zoom level
    // Add a tile layer from OpenStreetMap or Mapbox
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '© OpenStreetMap contributors'
    }).addTo(this.map);
  }
  
  copyClipBoard(elementId: string):void{
    var copyText:any=document.getElementById(elementId);

    navigator.clipboard.writeText(copyText.textContent)
    .then(()=> {
      alert("ID Copied in Clipboard!");
    })
    .catch(err=> {
      console.error("Failed to copy:", err);
    })
    
  }
}
